// extracted by mini-css-extract-plugin
export default {"actionBox":"material-confirmation-tabs_actionBox__kTSKc"};